import { isDateUpToToday } from "@/core/dayMonthYearConstraints";
import { emptyToUndefined } from "@/core/helpers";
import { greekMessages } from "@/plugins/yup-localization";
import { isValidDate } from "@/views/checkouts/schemas/validators";
import * as yup from "yup";

const phoneNumberRegex = /^\d{10}$/;
const addressNumberRegex = /^\d+(?:\s*,?\s*\p{L}{1,2})?(?:\s*-\s*(?:\d+(?:\s*,?\s*\p{L}{1,2})?|\p{L}{1,2}))?(?:(?:\s*,\s*|\s+(?=\d))\d+(?:\s*,?\s*\p{L}{1,2})?(?:\s*-\s*(?:\d+(?:\s*,?\s*\p{L}{1,2})?|\p{L}{1,2}))?)*\s*,?$/u

export const BaseSchemaBuilder = (
        fatherName,
        showLandline,
        legalEntity,
        freelancer,
        discountEntity
    ) => {
    let schema = {
        email: yup.string().trim().email().required(),
        cellphone_num: yup
            .string()
            .matches(phoneNumberRegex, { 
                excludeEmptyString: true,
                message: greekMessages.string.mobile
            })
            .required(),
        address: yup.string().required(),
        address_no: yup
            .string()
            .transform(emptyToUndefined)
            .matches(addressNumberRegex, {
                excludeEmptyString: true,
                message: greekMessages.string.matches,
            })
            .required(),
        tax_no: yup
            .string()
            .matches(/^\d+$/, {
                message: greekMessages.mixed.isValidAFM,
            })
            .length(9, greekMessages.mixed.isValidAFM)
            .required(),
        usedVehicle: yup.boolean().required(),
        transferDate: yup.object().when('usedVehicle', {
            is: true,
            then: () =>
                yup.object({
                    month: yup.number().integer().required(),
                    year: yup.number().integer().required(),
                }).test(
                    'isAfterOrSameAsManufactureDate',
                    greekMessages.mixed.isAfterOrSameAsManufactureDate,
                    function(value) {
                        const manufactureDate = new Date(parseInt(this.from[1].value.vehicle?.manufactureYear, 10), parseInt(this.from[1].value.vehicle?.manufactureMonth) - 1, 10);
                        const transferDate = new Date(value.year, parseInt(this.from[0].value.month) - 1, 10)

                        return transferDate >= manufactureDate;
                    }
                ).test('isDateUpToToday', greekMessages.mixed.isValidDate, isDateUpToToday).test('isValidDate', greekMessages.mixed.isValidDate, isValidDate).required(),
            otherwise: () => yup.mixed().strip(),
        }),
        startDate: yup
        .object({
            day: yup.string().required(),
            month: yup.string().required(),
            year: yup.string().required(),
        })
        .required()
        .test(
            "start-date-not-in-past",
            "Η ημερομηνία έναρξης δεν μπορεί να είναι παρελθοντική",
            (value) => {
                if (!value) return false;

                const day = Number.parseInt(value.day, 10);
                const month = Number.parseInt(value.month, 10) - 1;
                const year = Number.parseInt(value.year, 10);

                if (Number.isNaN(day) || Number.isNaN(month) || Number.isNaN(year)) {
                    return false;
                }

                const selectedDate = new Date(year, month, day);

                if (
                    selectedDate.getFullYear() !== year ||
                    selectedDate.getMonth() !== month ||
                    selectedDate.getDate() !== day
                ) {
                    return false;
                }

                const today = new Date();
                today.setHours(0, 0, 0, 0);
                selectedDate.setHours(0, 0, 0, 0);

                return selectedDate >= today;
            }
        ),
    };

    if (legalEntity) {
        schema = {
            ...schema,
            name: yup.string().strip(),
            surname: yup.string().strip(),
            father_name: yup.string().strip(),
            company_name: yup.string().required(),
        };
    } else {
        schema = {
            ...schema,
            name: yup.string().required(),
            surname: yup.string().required(),
            company_name: yup.string().strip(),
        };
    }

    if (fatherName && !legalEntity) {
        schema = {
            ...schema,
            father_name: yup.string().required(),
        };
    } else if (!legalEntity) {
        schema = {
            ...schema,
            father_name: yup.string().strip(),
        };
    }

    if (showLandline) {
        schema = {
            ...schema,
            landline_num: yup.string().required(),
        };
    }

    if (freelancer && !discountEntity) {
        schema = {
            ...schema,
            occupation_type: yup.string().required(),
        };
    }

    return schema;
};

export default BaseSchemaBuilder;
